module.exports = __webpack_public_path__ + "img/capsule-main-image.cf46f2fb.png";